import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e262a7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "homepage-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Forside indhold", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hint" }, "Teksterne vises på forsiden under billederne.", -1))
const _hoisted_4 = {
  key: 0,
  class: "image-list"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "image-desc" }
const _hoisted_7 = { class: "image-actions" }
const _hoisted_8 = {
  key: 1,
  class: "no-images"
}
const _hoisted_9 = {
  key: 0,
  class: "text-success"
}
const _hoisted_10 = {
  key: 1,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_form_textarea = _resolveComponent("b-form-textarea")!
  const _component_b_form_text = _resolveComponent("b-form-text")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_select_image_modal = _resolveComponent("select-image-modal")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_b_form, {
      onSubmit: _withModifiers(_ctx.save, ["prevent"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_form_group, { label: "Velkomsttitel" }, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_input, {
              modelValue: _ctx.form.welcomeTitle,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.welcomeTitle) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_b_form_group, { label: "Velkomsttekst" }, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_textarea, {
              modelValue: _ctx.form.welcomeText,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.welcomeText) = $event)),
              rows: "4"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_b_form_group, { label: "Upload-opfordring" }, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_input, {
              modelValue: _ctx.form.uploadPrompt,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.uploadPrompt) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_b_form_text, null, {
              default: _withCtx(() => [
                _createTextVNode("Vises som diskret tekst under billederne på forsiden.")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_form_group, { label: "Forsidebilleder" }, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_text, { class: "mb-2" }, {
              default: _withCtx(() => [
                _createTextVNode(" Disse billeder vises i slideshowet og collaget på forsiden. Rækkefølgen bestemmer visningsrækkefølgen. Efterlades listen tom vælges billeder automatisk fra den nyeste tur. ")
              ]),
              _: 1
            }),
            (_ctx.frontpageImages.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frontpageImages, (image, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: image.id,
                      class: "image-row"
                    }, [
                      _createElementVNode("img", {
                        src: (image.thumbUri || image.uri) + '?' + _ctx.token,
                        class: "image-thumb"
                      }, null, 8, _hoisted_5),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(image.description || `Billede ${image.id}`), 1),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_b_button, {
                          size: "sm",
                          variant: "outline-secondary",
                          disabled: idx === 0,
                          onClick: ($event: any) => (_ctx.moveUp(idx))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("↑")
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"]),
                        _createVNode(_component_b_button, {
                          size: "sm",
                          variant: "outline-secondary",
                          disabled: idx === _ctx.frontpageImages.length - 1,
                          onClick: ($event: any) => (_ctx.moveDown(idx))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("↓")
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"]),
                        _createVNode(_component_b_button, {
                          size: "sm",
                          variant: "outline-danger",
                          onClick: ($event: any) => (_ctx.removeImage(idx))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("✕")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_8, "Ingen billeder valgt — automatisk valg er aktivt.")),
            _createVNode(_component_b_button, {
              variant: "outline-primary",
              class: "mt-2",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showImageModal = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Tilføj billede ")
              ]),
              _: 1
            }),
            _createVNode(_component_select_image_modal, {
              "show-modal": _ctx.showImageModal,
              "onUpdate:showModal": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showImageModal) = $event)),
              title: "Vælg billede til forsiden",
              images: _ctx.allImages,
              onSelected: _ctx.addImage
            }, null, 8, ["show-modal", "images", "onSelected"])
          ]),
          _: 1
        }),
        (_ctx.successMessage)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.successMessage), 1))
          : _createCommentVNode("", true),
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.errorMessage), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_b_button, {
          type: "submit",
          variant: "success",
          disabled: _ctx.saving
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.saving ? 'Gemmer...' : 'Gem ændringer'), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}